import { render, staticRenderFns } from "./bicoin.vue?vue&type=template&id=3ab81466&scoped=true&"
import script from "./bicoin.vue?vue&type=script&lang=js&"
export * from "./bicoin.vue?vue&type=script&lang=js&"
import style0 from "./bicoin.vue?vue&type=style&index=0&id=3ab81466&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab81466",
  null
  
)

export default component.exports